import { Container } from '../../common/container/Container'

export type CalendarContainerConfig = {
  moduleFullUrl: string
}

export type CalendarProps = {
  parentContainer: Container
  config: CalendarContainerConfig
}

export const CALENDAR_MODULE = Symbol('CALENDAR_MODULE')

export const EVENT_API_KEY = Symbol('EVENT_API_KEY')

export const EVENT_SERVICE_KEY = Symbol('EVENT_SERVICE_KEY')

export const APPOINTMENT_API_KEY = Symbol('APPOINTMENT_API_KEY')

export const APPOINTMENT_SERVICE_KEY = Symbol('APPOINTMENT_SERVICE_KEY')

export const EXTERN_APPOINTMENT_API_KEY = Symbol('APPOINTMENT_API_KEY')

export const EXTERN_APPOINTMENT_SERVICE_KEY = Symbol('APPOINTMENT_SERVICE_KEY')

export const NOTE_API_KEY = Symbol('NOTE_API_KEY')

export const NOTE_SERVICE_KEY = Symbol('NOTE_SERVICE_KEY')

export const TASK_API_KEY = Symbol('TASK_API_KEY')

export const TASK_SERVICE_KEY = Symbol('TASK_SERVICE_KEY')

export const EXTERN_APPOINTMENT_SCHEDULE_API_KEY = Symbol('EXTERN_APPOINTMENT_SCHEDULE_API_KEY')

export const EXTERN_APPOINTMENT_SCHEDULE_SERVICE_KEY = Symbol(
  'EXTERN_APPOINTMENT_SCHEDULE_SERVICE_KEY'
)
